var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.19 61.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #231916;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.19px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30D9\\u30FC\\u30B9",
    "data-name": "\\u30D9\\u30FC\\u30B9"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.59 32.9 30.65 1.6 1.6 32.9 11.25 32.9 11.25 60.29 50.56 60.29 50.56 32.9 60.59 32.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.5b04456268f45c0775317c35ae7c8736.svg";
export { ForwardRef as ReactComponent };